module.exports = __webpack_public_path__ + "img/modeler-side.da20c1f3.png";